export const UnitStartType = {
  Fast: "FAST",
  Slow: "SLOW"
};
